module.exports = __webpack_public_path__ + "static/build-and-automate-process-111ebbfc11f69b52bf066c24f54d71ac.mp4";